// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedModuleElement: null
}

const moduleElements = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_MODULE_ELEMENTS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_MODULE_ELEMENTS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_MODULE_ELEMENT':
      return { ...state, selectedModuleElement: action.selectedModuleElement }
    case 'ADD_MODULE_ELEMENT':
      return { ...state }
    case 'DELETE_MODULE_ELEMENT':
      return { ...state }
    default:
      return { ...state }
  }
}
export default moduleElements
